import { get, some } from 'lodash';

function noneSelected(checkboxes = []) {
  return !some(checkboxes, (c) => get(c, 'selected.value', false));
}

export default noneSelected;
